<template>
  <div class="modal-invoice-view-wrap">
    <portal to="dash-modal">
      <InvoiceFinanceModal
        v-if="!financingLoading && !loading && displayFinanceModal && invoicePDF"
        :invoice="invoice"
        :invoice-pdf="invoicePDF"
        :financing="financing"
        @close="closeFinanceModal"
        @financingCreated="onFinancingCreated"
      />

      <!-- only for mark as sent -->
      <InvoiceSendAdjustModal
        v-if="!showInvoicesModal && showAdjustModal && invoice"
        :invoice-id="invoice.id"
        :mark-as-sent="markedAsSent"
        @close="closeAdjustModal"
        @marked-as-sent="() => { $emit('invoice-updated'); showAdjustModal = false }"
      />

      <InvoiceDesignModal
        v-if="showDesign"
        @layout-updated="refreshPDF"
        @close="closeDesignModal"
      />
    </portal>

    <!-- MAIN -->
    <div class="mastermodal-view-wrap">
      <div class="mastermodal-view--left" :class="{ rabobanner: (allowRaboFinancing && !isRecurrent) }">
        <div v-if="!isRecurrent" class="mastermodal-mobile-status">
          <InvoiceStatusBadge :is-quotation="isQuotation" />
        </div>
        <overlay-scrollbars :options="{ scrollbars: { autoHide: 'never' }, overflowBehavior: { y: 'scroll', x: 'hidden' }, className : 'os-theme-dark os-theme-gekko' }">
          <div v-if="detailView === 'details'" class="mastermodal-view-tabs--details">

            <div v-if="showRaboAlert" class="detail-tab--section detail-tab--section__financing">
              <b-alert show class="gk-alert mb-0" variant="info">
                <div @click="manualFinanceToggle()" class="cursor-pointer">
                  <h4>{{ $gettext('Receive payment now') }}</h4>
                  <div class="banner-content">
                    <ul>
                      <li>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88586 2.01299C5.03561 2.01299 1.91436 5.13424 1.91436 8.98449C1.91436 12.8347 5.03561 15.956 8.88586 15.956C12.7361 15.956 15.8574 12.8347 15.8574 8.98449C15.8574 8.03326 15.6672 7.12792 15.3233 6.30331L16.3957 5.85609C16.7976 6.81989 17.0193 7.87704 17.0193 8.98449C17.0193 13.4765 13.3778 17.1179 8.88586 17.1179C4.3939 17.1179 0.752441 13.4765 0.752441 8.98449C0.752441 4.49253 4.3939 0.851074 8.88586 0.851074C11.1242 0.851074 13.1523 1.75602 14.6224 3.21864C14.8242 3.41944 14.8508 3.73692 14.6851 3.96848L8.77742 12.2273C8.6781 12.3661 8.52275 12.4543 8.35262 12.4683C8.18249 12.4823 8.01481 12.4208 7.8941 12.3001L4.98931 9.39529L5.81091 8.57369L8.23111 10.9939L13.4427 3.70823C12.2203 2.65147 10.6281 2.01299 8.88586 2.01299Z" fill="#00AF89"/>
                        </svg>
                        <span>{{ $gettext('Amount transferred within 24 hours') }}</span>
                      </li>
                      <li>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88586 2.01299C5.03561 2.01299 1.91436 5.13424 1.91436 8.98449C1.91436 12.8347 5.03561 15.956 8.88586 15.956C12.7361 15.956 15.8574 12.8347 15.8574 8.98449C15.8574 8.03326 15.6672 7.12792 15.3233 6.30331L16.3957 5.85609C16.7976 6.81989 17.0193 7.87704 17.0193 8.98449C17.0193 13.4765 13.3778 17.1179 8.88586 17.1179C4.3939 17.1179 0.752441 13.4765 0.752441 8.98449C0.752441 4.49253 4.3939 0.851074 8.88586 0.851074C11.1242 0.851074 13.1523 1.75602 14.6224 3.21864C14.8242 3.41944 14.8508 3.73692 14.6851 3.96848L8.77742 12.2273C8.6781 12.3661 8.52275 12.4543 8.35262 12.4683C8.18249 12.4823 8.01481 12.4208 7.8941 12.3001L4.98931 9.39529L5.81091 8.57369L8.23111 10.9939L13.4427 3.70823C12.2203 2.65147 10.6281 2.01299 8.88586 2.01299Z" fill="#00AF89"/>
                        </svg>
                        <span>{{ $gettext('Takes 2 minutes to request') }}</span>
                      </li>
                      <li>
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path fill-rule="evenodd" clip-rule="evenodd" d="M8.88586 2.01299C5.03561 2.01299 1.91436 5.13424 1.91436 8.98449C1.91436 12.8347 5.03561 15.956 8.88586 15.956C12.7361 15.956 15.8574 12.8347 15.8574 8.98449C15.8574 8.03326 15.6672 7.12792 15.3233 6.30331L16.3957 5.85609C16.7976 6.81989 17.0193 7.87704 17.0193 8.98449C17.0193 13.4765 13.3778 17.1179 8.88586 17.1179C4.3939 17.1179 0.752441 13.4765 0.752441 8.98449C0.752441 4.49253 4.3939 0.851074 8.88586 0.851074C11.1242 0.851074 13.1523 1.75602 14.6224 3.21864C14.8242 3.41944 14.8508 3.73692 14.6851 3.96848L8.77742 12.2273C8.6781 12.3661 8.52275 12.4543 8.35262 12.4683C8.18249 12.4823 8.01481 12.4208 7.8941 12.3001L4.98931 9.39529L5.81091 8.57369L8.23111 10.9939L13.4427 3.70823C12.2203 2.65147 10.6281 2.01299 8.88586 2.01299Z" fill="#00AF89"/>
                        </svg>
                        <span>{{ $gettext('Interest rate between 1.2% en 3.5%') }}</span>
                      </li>
                    </ul>
                  </div>
                  <div class="rabo-button-wrap">
                    <GekkoButton
                      @click="manualFinanceToggle()"
                      :text="$gettext('Request financing')"
                      class="rabo-btn"
                    />
                    <div class="rabo-logo">
                      <img src="/static/img/third-party/rabobank-text-logo.png">
                    </div>
                  </div>

                </div>
              </b-alert>
            </div>
            <div v-else-if="!financingLoading && financing && financing.status === 'success'">
              <b-alert show class="gk-alert mb-0 rounded-none" variant="success">
                {{ this.$gettext("RaboBank financing has been requested for this invoice.")}}
              </b-alert>
            </div>

            <div v-if="debug" class="detail-tab--section">
              <div class="detail-tab--section__line text-danger">
                <h4>Debug</h4>
              </div>
              <div class="detail-tab--section__line text-danger">
                <div class="">
                  {{ userAgent }}
                </div>
              </div>
              <div class="detail-tab--section__line text-danger">
                <div>Mobile OS</div>
                <div class="">
                  {{ mobileOS }}
                </div>
              </div>
              <div class="detail-tab--section__line text-danger">
                <div>PDF Viewer</div>
                <div class="">
                  {{ (viewerEnabled) ? 'Enabled' : 'Disabled' }}
                </div>
              </div>
            </div>

            <div class="detail-tab--section">
              <!-- TOTAL -->
              <div class="detail-tab--section__line">
                <h4>{{ $gettext('Total') }}</h4>
                <div class="total-amount" v-html="totalAmount" />
              </div>

              <!-- Number / name -->
              <div v-if="!isRecurrent" class="detail-tab--section__line">
                <div v-if="isQuotation">{{ $gettext('Quotation number') }}</div>
                <div v-else>{{ $gettext('Invoice number') }}</div>
                <div class="strong">
                  {{ invoice.number }}
                </div>
              </div>

              <!-- Date / period -->
              <div class="detail-tab--section__line">
                <div v-if="isQuotation">{{ $gettext('Quotation date') }}</div>
                <div v-else>{{ $gettext('Invoice date') }}</div>
                <div class="">
                  {{ invoice.invoice_date | formatDate('DD-MM-YYYY') }}
                </div>
              </div>
              <div v-if="invoice.status !== 'p' && !invoice.paid_up_front" class="detail-tab--section__line">
                <div v-if="isQuotation">{{ $gettext('Valid until') }}</div>
                <div v-else>{{ $gettext('Payment due') }}</div>
                <div class="">
                  {{ invoice.due_date | formatDate('DD-MM-YYYY') }}
                </div>
              </div>
              <div class="detail-tab--section__line">
                <div>{{ $gettext('Customer') }}</div>
                <div class="">
                  {{ invoice.recipient_customer.name }}
                </div>
              </div>
              <div v-if="invoice.project" class="detail-tab--section__line">
                <div>{{ $gettext('Project') }}</div>
                <div class="">
                  {{ invoice.project.name }}
                </div>
              </div>
            </div>


            <!-- Schedule summary -->
            <div v-if="scheduleSummary" @click="$store.commit('invoicesRecurrent/TOGGLE_MODAL')" class="detail-tab--section cursor-pointer">
              <div class="detail-tab--section__line">
                <h4>{{ $gettext('Scheduled') }}</h4>
              </div>
              <div class="detail-tab--section__line">
                <div class="">
                  <b-alert show class="gk-alert mb-0" variant="info">
                    <font-awesome-icon icon="fa-regular fa-clock-rotate-left" />
                    {{ scheduleSummary }}
                  </b-alert>
                </div>
              </div>
            </div>


            <!-- Files -->
            <div v-if="isQuotation && attachedDocuments && attachedDocuments.length > 0" class="detail-tab--section">
              <div class="detail-tab--section__line">
                <h4>{{ $gettext('Files') }}</h4>
              </div>
              <div v-for="file in attachedDocuments" :key="file.id" class="detail-tab--section__line">
                <div>{{ file.title }}</div>
                <div>
                  <GekkoButton
                    @click="downloadDocument(file)"
                    icon="fa-solid fa-download"
                    variant="link"
                    class="text-info p-0"
                    size="sm"
                  />
                </div>
              </div>
            </div>

            <!-- Message -->
            <div v-if="invoice.message && invoice.message != ''" class="detail-tab--section">
              <div class="detail-tab--section__line">
                <h4>{{ $gettext('Message') }}</h4>
              </div>
              <div class="detail-tab--section__line">
                <div class="">
                  {{ invoice.message }}
                </div>
              </div>
            </div>

           <!-- History -->
            <div v-if="!isRecurrent" class="detail-tab--section">
              <div class="detail-tab--section__line">
                <h4>{{ $gettext('History') }}</h4>
              </div>
              <div class="detail-tab--section__line">
                <TimelineWidget v-if="invoiceId && !isQuotation" :widget="{ config: { object_type: 'invoice', invoice_id: invoiceId } }" />
                <TimelineWidget v-if="invoiceId && isQuotation" :widget="{ config: { object_type: 'quotation', quotation_id: invoiceId } }" />
              </div>
            </div>

          </div>
        </overlay-scrollbars>
      </div>

      <div class="mastermodal-view--right" :class="{ 'expanded': previewExpanded, 'has-badge': !currentCompany.is_premium }">
        <div class="mastermodal-view--right__handle" @click="previewExpanded = !previewExpanded"/>
        <div class="mastermodal-view--right__document">
          <InvoicePDFPreview
            :is-quotation="isQuotation"
            :key="previewPDFId"
            :invoice-id="invoiceId"
            ref="invoice-pdf-preview"
            @show-design="showDesign = true"
          />
        </div>

        <div v-if="!currentCompany.is_premium" class="mastermodal-view--right__poweredby">
          <div @click="goToSubscriptions()" id="tt-premium-powered">
            <GkLogo :full="false" :fill="'brand'" /> {{ $gettext('powered by getgekko.com') }}
          </div>
          <b-tooltip :custom-class="'tooltip-padded'" target="tt-premium-powered" placement="top" triggers="hover">
            <div class="tooltip-title">
              {{ $gettext('Powered by getgekko.com') }}
            </div>
            <div class="tooltip-text">
              {{ $gettext('To remove the Gekko logo on your invoice, upgrade to Premium.') }}
            </div>
          </b-tooltip>
        </div>

        <div v-if="!isRecurrent" class="mastermodal-view--right__statuswrap">
          <InvoiceStatusBadge :is-quotation="isQuotation" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapMutations, mapActions } from "vuex";

import { promptDownload } from "@/utils/"

import invoices from "@/mixins/invoices";
import pdfviewer from "@/mixins/pdfviewer";

import GekkoButton from "@/components/GekkoButton"
import LoadingSpinner from "@/components/dashboard/ui/LoadingSpinner"
import GkLogo from "@/components/ui/GkLogo.vue";

import InvoiceFinanceModal from "@/components/invoices/ui/InvoiceFinanceModal";
import InvoiceSendAdjustModal from "@/components/invoices/ui/InvoiceSendAdjustModal"
import InvoicePDFPreview from "@/components/invoices/ui/InvoicePDFPreview"
import InvoiceDesignModal from "@/components/invoices/ui/InvoiceDesignModal"
import InvoiceStatusBadge from "@/components/invoices/ui/InvoiceStatusBadge"
import TimelineWidget from "@/components/dashboard/widgets/TimelineWidget";
import FinancingService from "@/store/services/financing.service";
import DocumentService from "@/store/services/document.service";

export default {
  name: "InvoiceView",
  mixins: [invoices, pdfviewer],
  components: {
    GekkoButton,
    LoadingSpinner,
    GkLogo,
    InvoiceFinanceModal,
    InvoiceSendAdjustModal,
    InvoicePDFPreview,
    InvoiceDesignModal,
    InvoiceStatusBadge,
    TimelineWidget
  },
  props: {
    isQuotation: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      invoiceId: null,
      loading: true,
      showInvoicesModal: false,
      showFinanceModal: false,
      showDesign: false,
      manualFinanceModalToggle: false,
      showAdjustModal: false,
      modalType: null,
      markedAsSent: false,
      detailView: 'details',
      previewPDFId: null,
      previewExpanded: false,
      financing: null,
      financingLoading: true,

      debug: false,
    }
  },
  computed: {
    ...mapGetters({
      currentUserProfile: 'main/getCurrentUserProfile',
      currentCompany: "main/getCurrentCompany",
      currentLayout: "invoicesLayout/getCurrentLayout",
      creditableStatuses: 'invoices/getCreditableStatuses',
      invoice: "invoices/getInvoice",
      recurrentInvoice: "invoices/getRecurrentInvoice",
      invoiceToCopy: 'invoices/getInvoiceToCopy',
      invoicePDF: "invoices/getInvoicePDF",
      currencyByCode: "main/getCurrencyByCode",
      quotationFiles: 'invoices/getQuotationFiles',
      scheduleSummary: 'invoicesRecurrent/getSummary'
    }),
    showRaboAlert() {
      return !this.financingLoading && 
        (!this.financing || (this.financing && this.financing.status !== 'success')) && 
        this.allowRaboFinancing && !this.isRecurrent && this.currentUserProfile.show_rabo_notification
    },
    allowRaboFinancing () {
      let allow_financing = false
      if (this.invoice) {
        const financingConditions = {
          max_age: 10,
          min_amount: 1000,
          max_amount: 100000,
          min_payment_term: 10,
          max_payment_term: 90,
          status: 's',
          currency: 'EUR'
        }

        const today = new Date(), past_date = new Date(today), invoice_date = new Date(this.invoice.invoice_date)
        past_date.setDate(today.getDate() - (financingConditions.max_age + 1)) // +1 include 10th day

        const is_valid_date = invoice_date >= past_date
        const is_valid_status = (this.invoice.status === financingConditions.status)
        const is_valid_amount = (financingConditions.min_amount <= this.invoice.total_amount && this.invoice.total_amount < financingConditions.max_amount)
        const is_valid_currency = (this.invoice.currency === financingConditions.currency)
        const is_valid_term = (this.invoice.payment_term > financingConditions.min_payment_term && this.invoice.payment_term < financingConditions.max_payment_term)

        // checking: amount, status, currency, date and due_date
        if (is_valid_amount && is_valid_status && is_valid_currency && is_valid_date && is_valid_term) {
          allow_financing = true
        } else {
          // console.log('is valid date', is_valid_date)
          // console.log('is valid status', is_valid_status)
          // console.log('is valid amount', is_valid_amount)
          // console.log('is valid currency', is_valid_currency)
          // console.log('is valid term', is_valid_term)
        }
      }
      return allow_financing
    },
    displayFinanceModal () {
      let display_modal = false
      if (this.manualFinanceModalToggle) {
        display_modal = this.showFinanceModal
      } else {
        // automatic modal popup disabled
        // display_modal = !this.showInvoicesModal && this.allowRaboFinancing && (this.currentUserProfile.show_rabo_notification || this.showFinanceModal)
      }
      return display_modal
    },
    isSent () {
      return (this.invoice && this.invoice.status === 's')
    },
    isRecurrent () {
      return (this.invoice && this.invoice.status === 'recurrent')
    },
    isUploaded () {
      return (this.invoice && this.invoice.uploaded)
    },
    attachedDocuments () {
      return this.quotationFiles
    },
    isEUR () {
      return (this.invoice.currency === 'EUR')
    },
    isPaid () {
      return this.invoice.amount_to_be_paid && (this.invoice.amount_to_be_paid == 0) && (this.invoice.total_amount > 0)
    },
    totalAmountEUR () {
      return this.$options.filters.currencyString(this.invoice.total_amount, 'EUR')
    },
    totalAmountCurrency () {
      return this.$options.filters.currencyString(this.invoice.currency_total_amount, this.invoice.currency)
    },
    amountToBePaidEUR () {
      return this.$options.filters.currencyString(this.invoice.amount_to_be_paid, 'EUR')
    },
    totalAmount () {
      let total_amount = 0

      if (this.isEUR) {
        total_amount = this.totalAmountEUR
      } else {
        if (this.invoice.total_amount && this.invoice.total_amount > 0) {
          total_amount = this.totalAmountCurrency + ' <span>(' + this.totalAmountEUR + ')</span>'
        } else {
          total_amount = this.totalAmountCurrency
        }
      }

      return total_amount
    },
    pendingAmount () {
      let pending_amount = 0
      if (this.isEUR) {
        pending_amount = this.amountToBePaidEUR
      } else {
        if (this.invoice.total_amount > 0) {
          pending_amount = this.amountToBePaidEUR
        } else {
          pending_amount = this.totalAmountCurrency
        }
      }

      return pending_amount
    }
  },
  watch: {
    $route: {
      immediate: true,
      handler (to) {
        this.showInvoicesModal = to.meta.showInvoicesModal
        this.modalType = to.meta.modalType
      }
    }
  },
  created () {
    this.invoiceId = (this.isQuotation) ? this.$route.params['quotationId'] : this.$route.params['invoiceId']
    this.previewPDFId = (this.isQuotation) ? this.$route.params['quotationId'] : this.$route.params['invoiceId']
    if (this.invoiceId) {
      this.setupData()
    }
  },
  mounted () {
    FinancingService.get(this.invoiceId)
        .then(response => this.financing = response.data)
        .catch(() => {})
        .finally(() => {
          this.financingLoading = false
        })
  },
  methods: {
    ...mapActions({
      setInvoiceToCopy: 'invoices/setInvoiceToCopy',
    }),
    ...mapMutations({
      setInvoicePDF: 'invoices/SET_INVOICE_PDF',
    }),
    setupData () {
      if (this.invoice) {
        console.log('view this.invoice', this.invoice)
        if (!this.isRecurrent) {
          this.$emit('display-buttons', 'view')
        } else {
          this.$emit('display-buttons', 'view-recurrent')
        }
      } else {
        console.log('Invoice is not set')
      }
      this.loading = false
    },
    closeInvoicesModal () {
      this.showInvoicesModal = false
      this.modalType = null
      this.$router.push({ name: 'InvoiceView', params: { invoiceId: this.invoiceId } })
    },
    closeFinanceModal () {
      this.manualFinanceModalToggle = true
      this.showFinanceModal = false
      if (window.mixpanel) {
        window.mixpanel.track('Rabobank: finance modal closed')
      }
    },
    onFinancingCreated (data) {
      this.financing = data
    },
    closeAdjustModal () {
      this.showAdjustModal = false
    },
    closeDesignModal () {
      this.showDesign = false
    },
    manualFinanceToggle () {
      this.manualFinanceModalToggle = true
      this.showFinanceModal = true
      if (window.mixpanel) {
        window.mixpanel.track('Rabobank: invoice view banner open')
      }
    },
    refreshPDF () {
      console.log('refreshPDF')
      this.showDesign = false
      this.setInvoicePDF(null)
      this.previewPDFId++ // to refresh PDF file after layout update
    },
    goToSubscriptions () {
      window.location.href = window.Urls['subscriptions:manage']()
    },
    downloadDocument(item) {
      DocumentService.getDocumentBlob(item.id).then(response => {
        promptDownload(response)
      }).catch(error => console.error('Error downloading Document:', error));
    }
  }
}
</script>
<style scoped lang="scss">
  .modal-invoice-view-wrap {
    height: 100%;
  }
  .mastermodal-view-wrap {
    .detail-tab--section__financing {
      font-family: MyriadPro, sans-serif;
      -webkit-font-smoothing: antialiased;
      .gk-alert {
        padding: 1rem;
        font-size: 1rem;
        border-radius: 8px;
        border: none;
        background: white;
        border: 1px solid #E0E0E1;
        h4 {
        font-family: MyriadPro, sans-serif;
          margin-top: 0 !important;
          margin-bottom: 1rem !important;
          color: #0058FF;
          font-style: italic;
          font-size: 24px;
          line-height: 28.8px;
        }
        .banner-content {
          color: #737578;
          margin-bottom: 1.25rem;
          ul {
            margin: 0;
            padding: 0;
            li {
              display: flex;
              margin-bottom: 0.25rem;
              gap: 0.25rem;
              margin-right: 0.5rem;
              svg {
                height: 22px;
                width: 22px;
              }
              span {}
            }
          }
        }
      }
      .rabo-button-wrap {
        display: flex;
        align-items: flex-end;
        flex-direction: column;
        gap: 1rem;

        .rabo-btn {
          background: #FF6700;
          border: 1px solid transparent;
          border-radius: 4px;
          padding: 12px 24px;
          font-size: 19px;
          line-height: 1;
          font-family: MyriadPro, sans-serif;
          font-weight: bold;
          transition-duration: 0.4s;
          transition-property: color, background-color, border;
          transition-timing-function: cubic-bezier(0.5, 1, 0.89, 1);
          height: 48px;
          width: 100%;
          -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
          -webkit-font-smoothing: antialiased;
          &:hover {
            transition: none;
            background-color: rgb(255, 133, 51);
          }
        }
        .rabo-logo {
          flex: 1;
          text-align: center;
          width: 100%;
          img {
            width: 70px;
          }
        }
      }
    }

    @media (min-width: '576px') {
      .mastermodal-view--left {
        &.rabobanner {
          min-width: 360px;
        }
      }
      .detail-tab--section__financing {
        .rabo-button-wrap {
          flex-direction: row;
          gap: 0;
          .rabo-btn {
            width: auto;
          }
          .rabo-logo {
            text-align: right;
            width: auto;
          }
        }
      }
    }

  }
</style>

<style lang="scss">

</style>